"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypes = void 0;
var ProjectTypes;
(function (ProjectTypes) {
    ProjectTypes["BACKEND"] = "BACKEND";
    ProjectTypes["DASHBOARD"] = "DASHBOARD";
    ProjectTypes["RETAIL"] = "RETAIL";
    ProjectTypes["ANALYTICS"] = "ANALYTICS";
    ProjectTypes["STOP_N_GO"] = "STOP_N_GO";
    ProjectTypes["MOBILE"] = "MOBILE";
    ProjectTypes["ADMIN"] = "ADMIN";
})(ProjectTypes = exports.ProjectTypes || (exports.ProjectTypes = {}));
